import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'
import { Content, Step } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const {
  CONTENT,
  CHECK_SYMPTOMS,
  BOOK_APPOINTMENT,
  PRESCRIPTION,
  CONFIG_WITH_FAMILY_AND_ELIGIBILITY,
} = USA
const { WELCOME, REGISTRATION, FAMILY, SUMMARY, ELIGIBILITY } = CONTENT

const partnerName = 'Babylon US Internal B360'

const welcomeContent: Step = {
  ...WELCOME.enUS,
  copy: [
    'As a Babylon US Internal Texas B360 member, you or your dependents can talk to a doctor and manage your health right from your phone, at no extra cost. Data rates may apply.',
  ],
}

const content: Content = {
  'en-US': {
    steps: [
      {
        ...welcomeContent,
        productFeatures: [
          {
            ...CHECK_SYMPTOMS.enUS,
          },
          {
            ...BOOK_APPOINTMENT.enUS,
            title:
              'Unlimited virtual doctor and therapist appointments, at a time that best fits your schedule, for you or your dependents.',
          },
          {
            ...PRESCRIPTION.enUS,
            title:
              'Get prescriptions sent to a local pharmacy of your choice (restrictions may apply)',
          },
        ],
      },
      {
        ...REGISTRATION.enUS,
        copy: ['Enter your details to register'],
      },
      {
        ...FAMILY.enUS,
        copy: [
          'Dependents covered by Babylon US Internal Texas B360 can also get unlimited access to Babylon, register them now.',
          'Add your family members now so they can access our services at no extra cost.',
        ],
      },
      ELIGIBILITY.enUS,
      SUMMARY.enUS,
    ],
    footerLinks: FOOTERLINKS.USA,
  },
}

const baseConfig: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...CONFIG_WITH_FAMILY_AND_ELIGIBILITY,
    id: 'babylon-us-internal-b-360',
    productConfigAppName: 'babylon-us-internal-b-360',
    name: partnerName,
    codes: {
      membership: 'BUITB360AUTOAPP',
    },
    partnerUrlSlug: 'BUITB360',
  },
  content,
}

const baseConfigWithDnaV2Design: PartnerConfig = {
  ...baseConfig,
  config: {
    ...baseConfig.config,
    useDnaV2Design: true,
  },
}

export default [baseConfig, baseConfigWithDnaV2Design]
